import '@fontsource/roboto-slab/400.css'
import '@fontsource/roboto-slab/500.css'
import '@fontsource/roboto-slab/900.css'
import '@fontsource/open-sans/400.css'
import '@fontsource/open-sans/600.css'

import { extendTheme } from '@chakra-ui/react'

export enum LayerStyles {
  SMALL_PILL = 'small-pill',
  LARGE_PILL = 'large-pill',
  MAIN_PILL = 'main-pill',
  BTN_INPUT_PILL = 'input-btn-pill',
  INPUT = 'input',
  EXTRA_LARGE_PILL = 'extra-large-pill',
}

export const redflagdeals = extendTheme({
  colors: {
    brand: '#c93827',
    white: '#fff',
    black: '#000',
    red: '#c93827',
    darkRed: '#d81e5d',
    darkBlack: '#000',
    blackAlpha: {
      50: 'rgba(51, 51, 51, 0.04)',
      100: 'rgba(51, 51, 51, 0.06)',
      200: 'rgba(51, 51, 51, 0.08)',
      300: 'rgba(51, 51, 51, 0.16)',
      400: 'rgba(51, 51, 51, 0.24)',
      500: 'rgba(51, 51, 51, 0.36)',
      600: 'rgba(0,  0, 0, 0.80)', //Mostly used for AlertDialogOverlay
      700: 'rgba(51, 51, 51, 0.64)',
      800: 'rgba(51, 51, 51, 0.80)',
      900: 'rgba(51, 51, 51, 0.92)',
    },
    whiteAlpha: {
      50: 'rgba(255, 255, 255, 0.04)',
      100: 'rgba(255, 255, 255, 0.06)',
      200: 'rgba(255, 255, 255, 0.08)',
      300: 'rgba(255, 255, 255, 0.16)',
      400: 'rgba(255, 255, 255, 0.24)',
      500: 'rgba(255, 255, 255, 0.36)',
      600: 'rgba(255, 255, 255, 0.48)',
      700: 'rgba(255, 255, 255, 0.64)',
      800: 'rgba(255, 255, 255, 0.80)',
      900: 'rgba(255, 255, 255, 0.92)',
    },
    // workaround for changing color of the progress bar as mentioned here - https://github.com/chakra-ui/chakra-ui/issues/569

    green: { 200: '#c93827', 500: '#c93827' },
    lightGreen: '#fff4f2',
    teal: '#00a69c',
    gray: '#d6e2e8',
    grey: '#d6e2e8',
    darkGrey: '#59595b',
    darkerGrey: '#3e3e52',
    purple: '#90278e',
    purpleAlpha: 'rgba(144,39,142,.2)',
    error: '#c93827',
  },

  components: {
    Button: {
      baseStyle: {
        borderRadius: 'md',
        fontWeight: 400,
        padding: '10px 16px',
        '&:focus': {
          boxShadow: 'none',
        },
      },
      defaultProps: {
        variant: 'outline',
      },
      variants: {
        outline: {
          border: '2px solid',
          borderColor: 'white',
        },
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: 400,
        textAlign: 'center',
        color: 'black',
      },
    },
    // Select is styled withing a component
    FluidImage: {
      baseStyle: {
        height: '60px',
      },
    },
  },
  fonts: {
    heading: `'Open Sans', sans-serif`,
    body: `'Open Sans', sans-serif`,
  },
  fontSizes: {
    xxs: '.82rem',
    xs: '.89rem',
    sm: '1.4rem',
    md: '1.75rem',
    lg: '1rem',
    xl: '1.4rem',
    '2xl': '1.58rem',
    '3xl': '1.8rem',
    '4xl': '2rem',
  },
  lineHeights: {
    2: '0.5rem',
    3: '.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    13: '3.25rem',
    14: '3.5rem',
    15: '3.75rem',
    16: '4rem',
  },
  radii: {
    default: '0',
    medium: '0',
    small: '0',
    lg: '0',
    xl: '0',
    '2xl': '0',
  },
  space: {
    1: '2px',
    2: '5px',
    3: '0',
    4: '16px',
    10: '4vw',
  },
  layerStyles: {
    [LayerStyles.SMALL_PILL]: {
      cursor: 'pointer',
      border: '1px',
      borderColor: 'green.500',
      borderRadius: '5px',
      bg: 'lightGreen',
      color: 'green.500',
      fontSize: 'xs',
      fontWeight: 700,
      paddingX: '16px',
      paddingY: '8px',
      marginX: 0.5,
      marginY: 1,
      _hover: {
        bg: '#ffe8e3',
      },
      _checked: {
        bg: 'green.500',
        color: 'white',
      },
    },
    [LayerStyles.LARGE_PILL]: {
      border: '1px',
      borderColor: 'grey',
      height: 'auto',
      minHeight: '70px',
      width: '298px',
      maxWidth: '80vw',
      padding: 2,
      marginBottom: 2,
      fontSize: 'xs',
      fontWeight: 'bold',
      borderRadius: '5px',
      whiteSpace: 'normal',
      margin: '15px auto 0',
      _hover: {
        border: '2px',
        borderColor: 'red',
      },
      _active: {
        border: '2px',
        borderColor: 'red',
      },
    },
    [LayerStyles.EXTRA_LARGE_PILL]: {
      border: '1px',
      borderColor: 'grey',
      height: '7.7vh',
      maxHeight: '70px',
      width: '50vh',
      maxWidth: '450px',
      padding: 6,
      marginBottom: 2,
      fontSize: 'xs',
      fontWeight: 'bold',
      borderRadius: 'full',
      whiteSpace: 'normal',
      margin: '15px auto 0',
      _hover: {
        border: '2px',
        borderColor: 'brand',
      },
      _active: {
        border: '2px',
        borderColor: 'brand',
      },
      _focus: {
        borderColor: 'brand',
        boxShadow: '0 0 0 2px #5bce4c',
      },
    },
    [LayerStyles.MAIN_PILL]: {
      cursor: 'pointer',
      backgroundColor: 'green.500',
      borderRadius: '2xl',
      color: 'white',
      fontSize: 'xs',
      fontWeight: 700,
      paddingX: '16px',
      paddingY: '8px',
      marginX: 0.5,
      marginY: 1,
    },
    [LayerStyles.BTN_INPUT_PILL]: {
      position: 'absolute',
      right: 2,
      top: 2,
      bottom: 2,
      width: 20,
      height: 'auto',
      size: '2xl',
      borderRadius: 'md',
      border: '2px solid transparent',
      backgroundColor: 'green.500',
      _hover: {
        backgroundColor: 'green.200',
      },
    },
    [LayerStyles.INPUT]: {
      outline: 'none',
      height: 85,
      paddingRight: 65,
      fontSize: 22,
      border: '2px solid transparent',
      borderColor: 'grey',
      borderRadius: 'md',
    },
    error: {
      fontWeight: 'bold',
      fontSize: 'large',
      textAlign: 'center',
      color: 'error',
    },
  },
  styles: {
    global: {
      body: {
        color: 'black',
        display: 'flex',
        minHeight: '100vh',
        flexDirection: 'column',
        margin: 0,
        textRendering: 'optimizeLegibility',
        fontSmooth: 'antialiased',
        WebkitFontSmoothing: 'antialiased',
        WebkitTapHighlightColor: 'transparent',
        whiteSpace: 'break-spaces',
      },
      '#root': {
        flex: 1,
      },
      input: {
        outline: 'none',
      },
      '.pac-target-input': {
        backgroundColor: 'transparent',
        '::placeholder': {
          color: 'green.500',
        },
      },
      '#currencyInput': {
        backgroundColor: 'transparent',
      },
      '.disabled': {
        pointerEvents: 'none',
        color: 'grey',
        cursor: 'none',
      },
      '.cky-policy': {
        color: '#012737 !important',
      },
      '.cky-policy:hover': {
        color: 'darkblue !important',
      },
      '.cky-btn': {
        borderColor: '#012737 !important',
      },
      '.cky-btn-customize': {
        color: '#012737 !important',
      },
      '.cky-btn-accept': {
        backgroundColor: '#012737 !important',
      },
      '.cky-switch input[aria-label~="Disable"]': {
        backgroundColor: '#012737 !important',
      },
      '.cky-switch input[aria-label*="sactiver"]': {
        backgroundColor: '#012737 !important',
      },
      '.cky-always-active': {
        color: '#012737 !important',
      },
      '.cky-btn-preferences': {
        color: '#012737 !important',
      },
      '.cky-title': {
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'space-between !important',
      },
      '.cky-custom-brand-logo': {
        padding: '0 0 0 0 !important',
      },
      '.cky-custom-brand-logo-wrapper': {
        display: 'flex !important',
        verticalAlign: 'middle !important',
      },
    },
  },
})
